import Card from 'components/card';
import { useState } from 'react';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import EmployeeSalaryDetails from './Steps/EmployeeSalaryDetails';
import SelectEmployee from '../AddMonthlySalary/Steps/SelectEmployee';
// import SelectEmployee from '../AddMonthlySalary/Steps/SelectEmployee';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [employeeData, setEmployeeData] = useState({
    employeeId: '',
  });
  const [employees, setEmployees] = useState([]);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);

  const [employeeTypes, setEmployeeTypes] = useState([
    { display: 'Accountant', value: 'Account' },
    { display: 'Admin', value: 'Admin' },
    { display: 'Placement', value: 'Placement' },
    { display: 'Teacher', value: 'Teacher' },
  ]);

  const handleNext = async () => {
    if (currentStep === 1) {
      setCurrentStep(2);
    }
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  const displayStep = (step) => {
    switch (step) {
      case 1:
        return (
          <SelectEmployee
            setDisable={setDisable}
            setEmployeeData={setEmployeeData}
            employeeData={employeeData}
            employeeTypes={employeeTypes}
            setEmployeesData={setEmployeesData}
            employeesData={employeesData}
          />
        );
      case 2:
        return (
          <EmployeeSalaryDetails
            employees={employees}
            employeeData={employeeData}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card
          extra={
            '-mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3'
          }
        >
          <div className="w-full rounded-[20px]">
            <UseContextProvider>{displayStep(currentStep)}</UseContextProvider>
          </div>
          <div className="flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            {currentStep === 2 && (
              <button
                onClick={handleBack}
                className="linear mb-2 cursor-pointer rounded-xl bg-gray-100 px-16 py-2 font-medium text-gray-900 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600 dark:active:bg-navy-500 md:mb-0 md:mr-2"
              >
                Back
              </button>
            )}
            {currentStep === 1 && (
              <button
                disabled={disable || loading}
                onClick={handleNext}
                className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                {loading ? 'Loading...' : 'Next'}
              </button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
